import NotificationBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/NotificationBadgeForCaseStatus.tsx";
import TabBadges from "@/components/Table/MrtCaseFilters/TabBadges.tsx";
import { Button, ButtonGroup } from "@mui/material";
import CaseTaskBadgeForCaseStatus from "./CaseTaskBadgeForCaseStatus";

type Props = {
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
};

const DisbursementSpecialistFilters = ({ selectedTab, setSelectedTab }: Props) => {
    return (
        <ButtonGroup aria-label="Basic button group" fullWidth sx={{ mb: 2 }}>
            <Button
                onClick={() => setSelectedTab("")}
                variant={selectedTab === "" ? "contained" : "outlined"}
            >
                All Cases
                <TabBadges />
            </Button>
            <Button
                onClick={() => setSelectedTab("Negotiation")}
                variant={selectedTab === "Negotiation" ? "contained" : "outlined"}
            >
                Negotiation
                <NotificationBadgeForCaseStatus caseStatus="Negotiation" />
                <CaseTaskBadgeForCaseStatus caseStatus="Negotiation" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Policy Limits")}
                variant={selectedTab === "Policy Limits" ? "contained" : "outlined"}
            >
                Policy Limits
                <NotificationBadgeForCaseStatus caseStatus="Policy Limits" />
                <CaseTaskBadgeForCaseStatus caseStatus="Policy Limits" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Hold Harmless")}
                variant={selectedTab === "Hold Harmless" ? "contained" : "outlined"}
            >
                Hold Harmless
                <NotificationBadgeForCaseStatus caseStatus="Hold Harmless" />
                <CaseTaskBadgeForCaseStatus caseStatus="Hold Harmless" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Checks Printed")}
                variant={selectedTab === "Checks Printed" ? "contained" : "outlined"}
            >
                Checks Printed
                <NotificationBadgeForCaseStatus caseStatus="Checks Printed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Checks Printed" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Disbursed")}
                variant={selectedTab === "Disbursed" ? "contained" : "outlined"}
            >
                Disbursed
                <NotificationBadgeForCaseStatus caseStatus="Disbursed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Disbursed" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Escrow")}
                variant={selectedTab === "Escrow" ? "contained" : "outlined"}
            >
                Escrow
                <NotificationBadgeForCaseStatus caseStatus="Escrow" />
                <CaseTaskBadgeForCaseStatus caseStatus="Escrow" />
            </Button>
        </ButtonGroup>
    );
};

export default DisbursementSpecialistFilters;
